import { render, staticRenderFns } from "./DesignContentLayout.vue?vue&type=template&id=f6552962&scoped=true"
import script from "./DesignContentLayout.vue?vue&type=script&lang=js"
export * from "./DesignContentLayout.vue?vue&type=script&lang=js"
import style0 from "./DesignContentLayout.vue?vue&type=style&index=0&id=f6552962&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6552962",
  null
  
)

export default component.exports